import { getUsers, editUser } from '@/api'
//
export default {
	namespaced: true,

	state: {
		session: null
	},

	mutations: {
		setSession (state, session) {
			state.session = session
		}
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js